import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { getMfaNotice } from "app/crud/mfa.crud";

const dismissedKey = (cutoverAt) => `mfa-notice-dismissed:${cutoverAt}`;

export default function MfaNoticeDialog({ authenticated = false }) {
  const [notice, setNotice] = useState(null);
  const hasRecommendedMfaSetup = useSelector(
    (state) => state.auth.mfaFlow?.kind === "login" && Boolean(state.auth.mfaFlow.setupToken)
  );

  useEffect(() => {
    let active = true;
    getMfaNotice()
      .then(({ data }) => {
        if (
          active &&
          data?.mfaCutoverAt &&
          sessionStorage.getItem(dismissedKey(data.mfaCutoverAt)) !== "true"
        ) {
          setNotice(data);
        }
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [authenticated]);

  if (!notice?.mfaCutoverAt || notice.enrolled === true || hasRecommendedMfaSetup) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(dismissedKey(notice.mfaCutoverAt), "true");
    setNotice(null);
  };

  return (
    <Dialog open onClose={handleDismiss} aria-labelledby="mfa-notice-title">
      <DialogTitle id="mfa-notice-title" className="f-20px text-dark p-30px pb-0">
        Two-factor authentication
      </DialogTitle>
      <DialogContent className="f-14px text-dark fw-300 pt-20px pb-0">
        {notice.noticeMessage}
      </DialogContent>
      <DialogActions className="p-30px">
        <button type="button" className="btn btn-primary btn-elevate py-3" onClick={handleDismiss}>
          Dismiss
        </button>
      </DialogActions>
    </Dialog>
  );
}
